var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"page-loading",rawName:"v-page-loading",value:(_vm.app.loading),expression:"app.loading"}],staticClass:"app",class:{ 'app--client': _vm.isClient },attrs:{"id":"app"}},[(!_vm.isClient)?_c('sidebar'):_vm._e(),_c('config-panel'),_c('preview')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }